module.exports = {
      id: "photostory-usage",
      viewBox: "0 0 50.625 54",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#photostory",
      toString: function () {
        return this.url;
      }
    }